import { useState, useCallback } from 'react';
import { useNotification } from '../../../../contexts/NotificationContext';

export const useAnalgesiaValidation = (patientData) => {
  const { showNotification } = useNotification();
  const [errors, setErrors] = useState({});

  const validateField = useCallback((name, value) => {
    let error = "";
    switch (name) {
      case 'assessment_date':
        if (!value) error = "Assessment date is required";
        break;
      case 'surgical_procedure':
        if (!value || !value.trim()) error = "Surgical procedure is required";
        break;
      case 'room_no':
        if (!value) error = "Room number is required";
        break;
      case 'ward_no':
        if (!value) error = "Ward number is required";
        break;
      case 'anesthesiologist':
        if (!value) error = "Anaesthesiologist is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  }, []);

  const validateForm = useCallback(() => {
    const requiredFields = [
      { key: 'assessment_date', label: 'Assessment Date' },
      { key: 'surgical_procedure', label: 'Surgical Procedure' },
      { key: 'room_no', label: 'Room No.' },
      { key: 'ward_no', label: 'Ward No.' },
      { key: 'anesthesiologist', label: 'Anaesthesiologist' },
    ];

    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!patientData[key] || String(patientData[key]).trim() === '') {
        tempErrors[key] = `${label} is required`;
      }
    });

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { 
        el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
        el.focus(); 
      }
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }

    return Object.keys(tempErrors).length === 0;
  }, [patientData, showNotification]);

  return { errors, setErrors, validateField, validateForm };
};
